import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';

import Forbidden from '@/assets/img/forbidden.png';
import { themeColors } from '@/config/theme/themeColors.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

export const ForbiddenView: React.FC = () => {
  const { t } = useTranslationWithPrefix('views.util.forbidden');

  return (
    <Stack
      direction="row"
      spacing={3}
      sx={{
        alignItems: 'flex-start',
        background: themeColors.white,
        height: '100vh',
        justifyContent: 'center',
        pt: 14,
      }}
    >
      <Stack
        spacing={4}
        sx={{
          justifyContent: 'center',
        }}
      >
        <img alt="Forbidden" src={Forbidden} />
        <Typography
          color={themeColors.accentColorDark}
          sx={{
            textAlign: 'center',
          }}
          variant="f32Medium"
        >
          {t('title')}
        </Typography>
        <Typography
          color={themeColors.accentColorDark}
          sx={{
            textAlign: 'center',
          }}
          variant="f24Medium"
        >
          {t('subtitle')}
        </Typography>
      </Stack>
    </Stack>
  );
};
